import { useRegistrationStore } from '../../hooks';
import { MenuCategoryRegistrationModalView } from '../../components/MenuCategoryRegistrationModalView';

export const MenuCategoryRegistrationModal = () => {
  const registrationStore = useRegistrationStore();

  return <MenuCategoryRegistrationModalView {...registrationStore} />;
};
